import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../api/store";
import { AmendmentModal, AmendmentModalOne } from "../../../types/type";
import { AmendmentRequest, AmendmentRequestData, RequestAmendmentState } from "./request-amendment.state";

const initialState: RequestAmendmentState = {
    proposalIdAmend: null,
    amendHistoryId: null,
    requestAmendment: null,
    amendmentModal: null,
    subAmendmentModal: null,
    amendmentModalOne: null,
    selectedRequestAmendment: null,
    notesReason: '',
    oldProposalData: null,
    hasProposedData: false,

};

const requestAmendmentSlice = createSlice({
    name: "requestAmendmentSlice",
    initialState,
    reducers: {
        setProposalIdAmendment: (state, action: PayloadAction<number | null>) => {
            state.proposalIdAmend = action.payload;
        },
        setAmendHistoryId: (state, action: PayloadAction<number | null>) => {
            state.amendHistoryId = action.payload;
        },
        setRequestAmendment: (state, action: PayloadAction<AmendmentRequest | null>) => {
            state.requestAmendment = action.payload;
        },
        setAmendmentModal: (state, action: PayloadAction<AmendmentModal>) => {
            state.amendmentModal = action.payload;
        },
        setSubAmendmentModal: (state, action: PayloadAction<null | 'viewProposeData' | 'viewProposedDataInHistory'>) => {
            state.subAmendmentModal = action.payload;
        },
        setAmendmentModalOne: (state, action: PayloadAction<AmendmentModalOne>) => {
            state.amendmentModalOne = action.payload;
        },
        setSelectedRequestAmendment: (state, action: PayloadAction<null | AmendmentRequestData>) => {
            state.selectedRequestAmendment = action.payload;
        },
        setNotesReason: (state, action: PayloadAction<string>) => {
            state.notesReason = action.payload;
        },
        setOldProposalData: (state, action: PayloadAction<any | null>) => {
            state.oldProposalData = action.payload;
        },
        setHasProposedData: (state, action: PayloadAction<boolean>) => {
            state.hasProposedData = action.payload;
        },
    }
});

export const {
    setRequestAmendment,
    setAmendHistoryId,
    setAmendmentModal,
    setSubAmendmentModal,
    setAmendmentModalOne,
    setSelectedRequestAmendment,
    setNotesReason,
    setOldProposalData,
    setProposalIdAmendment,
    setHasProposedData,
} = requestAmendmentSlice.actions;

export const selectRequestAmendment = (state: RootState) => state.requestAmendmentSlice.requestAmendment;
export const selectAmendHistoryId = (state: RootState) => state.requestAmendmentSlice.amendHistoryId;
export const selectAmendmentModal = (state: RootState) => state.requestAmendmentSlice.amendmentModal;
export const selectAmendmentModalOne = (state: RootState) => state.requestAmendmentSlice.amendmentModalOne;
export const selectSubAmendmentModal = (state: RootState) => state.requestAmendmentSlice.subAmendmentModal;
export const selectedRequestAmendment = (state: RootState) => state.requestAmendmentSlice.selectedRequestAmendment;
export const selectNotesReason = (state: RootState) => state.requestAmendmentSlice.notesReason;
export const selectOldProposalData = (state: RootState) => state.requestAmendmentSlice.oldProposalData;
export const selectProposalAmendId = (state: RootState) => state.requestAmendmentSlice.proposalIdAmend;
export const selectHasProposedData = (state: RootState) => state.requestAmendmentSlice.hasProposedData;

export default requestAmendmentSlice.reducer;